import http from './http';

/** A signed, agent-initiated call request (owner directive 2026-10-13 01:26). */
export interface AgentCallRequest {
  id: string;
  user_id: string;
  /** Stable slug: 'default' | 'ricardo' | 'henry' | module agent profile key. */
  agent_key: string;
  display_name: string;
  emoji: string | null;
  reason: string;
  payload: Record<string, unknown> | null;
  status: 'pending' | 'answered' | 'cancelled' | string;
  created_at: string | null;
  updated_at: string | null;
  answered_at: string | null;
  cancelled_at: string | null;
  cancel_reason: string | null;
  expires_at: string | null;
}

export interface AgentCallsListResponse {
  pending: AgentCallRequest[];
  count: number;
}

export const agentCallsApi = {
  /** The signed, pending calls for the signed-in user (polled by the widget). */
  list: () => http.get<AgentCallsListResponse>('/agent-calls').then(r => r.data),
  /** The owner ANSWERED the signed call. */
  answer: (id: string) =>
    http.post<{ status: string; request: AgentCallRequest }>(`/agent-calls/${id}/answered`, {}).then(r => r.data),
  /** The owner dismisses a signed call request. */
  cancel: (id: string, why?: string) =>
    http.post<{ status: string; cancelled: number }>(`/agent-calls/${id}/cancel`, { why: why ?? null }).then(r => r.data),
};
